/* global axios */

import ApiClient from './ApiClient';

class StorageCleanups extends ApiClient {
  constructor() {
    super('storage_cleanups', { accountScoped: true });
  }

  preview(params = {}) {
    return axios.get(this.url, {
      params: {
        start_date: params.start_date,
        end_date: params.end_date,
        page: params.page || 1,
        per_page: params.per_page || 20
      }
    });
  }

  cleanup(params = {}) {
    return axios.delete(this.url, {
      data: {
        start_date: params.start_date,
        end_date: params.end_date
      }
    });
  }
}

export default new StorageCleanups();
